import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setIsSelectingVehicle, setSelectedBrand, setSelectedYear, setSelectedModel, setSelectedVersion } from '../reducers/vehicle';
import { setSelectedSupplier } from '../reducers/search';
import '../App.css';
import './Header.css';
import AutoComplete from './AutoComplete';
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import VehicleFilter from './VehicleFilter';
import { contentData, configData } from '../Whitelabel/websitesData';

function Search({ setHasText }) {
  const [inputValue, setInputValue] = useState('');
  const navigate = useNavigate();
  const { selectedBrand, isSelectingVehicle, selectedYear, selectedModel, selectedVersion } = useSelector(state => state.vehicle);
  const { selectedSupplier = 'tudo' } = useSelector(state => state.search || {});
  const selectRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
        window.removeEventListener('resize', handleResize);
    };
  }, []);

  const dispatch = useDispatch();

  const adjustSelectWidth = () => {
    if (selectRef.current) {
      const select = selectRef.current;
      const selectedOption = select.options[select.selectedIndex];
      const tempSpan = document.createElement('span');
      tempSpan.style.visibility = 'hidden';
      tempSpan.style.position = 'absolute';
      tempSpan.style.whiteSpace = 'nowrap';
      tempSpan.style.fontSize = window.getComputedStyle(select).fontSize;
      tempSpan.style.fontFamily = window.getComputedStyle(select).fontFamily;
      tempSpan.textContent = selectedOption.text;
      document.body.appendChild(tempSpan);
      const width = tempSpan.offsetWidth;
      document.body.removeChild(tempSpan);
      select.style.width = `${width + 42}px`; // Increased padding to account for arrow and margins
    }
  };

  useEffect(() => {
    adjustSelectWidth();
  }, [selectedSupplier]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);
    setHasText(value !== '');
  };

  const clearInput = () => {
    setInputValue('');
    setHasText(false);
    document.getElementById('search').focus();
  };

  const openVehicleSelect = (type, data) => {
    if (type === 'brand') {
      dispatch(setSelectedBrand(''));
      dispatch(setSelectedYear(''));
      dispatch(setSelectedModel(''));
      dispatch(setSelectedVersion(''));
      dispatch(setSelectedBrand(data.toLowerCase()));
      dispatch(setIsSelectingVehicle(true));
      clearInput();
    }
  };
  
  const searchPlaceholder = configData.defaultStore === 'UmuaramaMotos'
    ? 'Buscar...'
    : selectedVersion 
      ? isMobile ? 'Peça ou código...' : 'Nome ou código da peça...'
      : 'Código da peça...';

  const handleSupplierChange = (event) => {
    const newSupplier = event.target.value;
    dispatch(setSelectedSupplier(newSupplier));
    adjustSelectWidth();
    
    // Only trigger search if there's a value in the input
    if (inputValue) {
      const supplierParam = newSupplier !== 'tudo' ? `?filter=${newSupplier}` : '';
      navigate(`/busca/${encodeURIComponent(inputValue)}${supplierParam}`);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
        event.preventDefault();
        const value = event.target.value;
        if (value != '') {
            const supplierParam = selectedSupplier !== 'tudo' ? `?filter=${selectedSupplier}` : '';
            navigate(`/busca/${encodeURIComponent(value)}${supplierParam}`);
            setHasText(false);
            // Hide keyboard by blurring the input
            event.target.blur();
        }
    }
  };

  // const handleFocus = () => {
  //   if ((configData.defaultStore !== 'UmuaramaHD' && configData.defaultStore !== 'UmuaramaMotos') && !selectedVersion) {
  //     dispatch(setIsSelectingVehicle(true));
  //   }
  // };

  return (
    <form className={`searchContainer ${inputValue ? 'focused' : 'notFocused'}`}>
      <input
        id='search'
        type='text'
        placeholder={searchPlaceholder}
        // onFocus={handleFocus}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        value={inputValue}
        className='searchInput'
        autoComplete="off"
        style={configData.defaultStore === 'Barigui' ? {height: '52px', fontSize: '18px', color: 'var(--textColor)'} : {}}
      />
      {/* {inputValue &&
        <div className='row searchButtons'>
          <div className='clearSearchButton' onClick={clearInput}>
            <CloseIcon style={{ color: 'var(--mainColor)' }} />
          </div>
        </div>
      } */}

      <div className='row searchButtons'>
        {inputValue &&
            <div className='clearSearchButton' onClick={clearInput}>
              <CloseIcon style={{ color: 'var(--mainColor)' }} />
            </div>
        }
        {configData.defaultStore === 'UmuaramaMotos' && (
          <select 
            ref={selectRef}
            className='searchFilter'
            value={selectedSupplier}
            onChange={handleSupplierChange}
            tabIndex="-1"
          >
            <option value='tudo'>Todas as marcas</option>
            <option value='harley-davidson'>Harley-Davidson</option>
            <option value='ktm'>KTM</option>
            <option value='triumph'>Triumph</option>
          </select>
        )}
        {(!configData.noVehicle) &&
          <div style={configData.defaultStore === 'Barigui' ? {marginRight: '2px'} : {}}>
            <VehicleFilter className='vehicleFilterButtonPosition'/>
          </div>
        }
      </div>

      {/* {inputValue && (configData.defaultStore !== 'UmuaramaHD' && configData.defaultStore !== 'UmuaramaMotos') && (
        <AutoComplete
          searchValue={inputValue}
          clearAutocomplete={clearInput}
          onAutoCompleteClick={openVehicleSelect}
        />
      )} */}
    </form>
  );
}

export default Search;
